export class WorkloadTimeOffPeriodEntity {
  public startDate!: string;
  public endDate!: string;
}

export class WorkloadEligibleDelegateEntity {
  public id!: string;
  public userId!: string;
  public name!: string;
  public role!: string;
  public upcomingTimeOff!: WorkloadTimeOffPeriodEntity[];
}

export class WorkloadManagedTeamEntity {
  public id!: string;
  public name!: string;
  public eligibleDelegates!: WorkloadEligibleDelegateEntity[];
}
